import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

export type LegalPage = 'imprint' | 'terms' | 'privacy';

/** Imprint, terms of service and privacy policy of PulseWatch (SM Tech GmbH). */
@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
  standalone: false,
})
export class LegalPageComponent {
  readonly page: LegalPage;
  readonly updated = 'September 2026';
  readonly year = new Date().getFullYear();

  readonly company = {
    name: 'SM Tech GmbH',
    street: 'Schlosstalstrasse 210',
    city: '8408 Winterthur',
    country: 'Switzerland',
    representative: 'Lukas Szwedowicz',
    email: 'hello@finitopro.ch',
  };

  constructor(route: ActivatedRoute) {
    this.page = route.snapshot.data['page'] ?? 'imprint';
  }
}
